var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRipple4X1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    width: "100%",
    height: "100%",
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "transparent"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 2,
    stroke: "#ffffff",
    fill: "none",
    r: 0,
    cy: 50,
    cx: 50
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    calcMode: "spline",
    keySplines: "0 0.2 0.8 1",
    keyTimes: "0;1",
    values: "0;53",
    dur: "1.4285714285714284s",
    repeatCount: "indefinite",
    attributeName: "r"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    calcMode: "spline",
    keySplines: "0.2 0 0.8 1",
    keyTimes: "0;1",
    values: "1;0",
    dur: "1.4285714285714284s",
    repeatCount: "indefinite",
    attributeName: "opacity"
  })), /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 2,
    stroke: "#ffffff",
    fill: "none",
    r: 0,
    cy: 50,
    cx: 50
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "-0.7142857142857142s",
    calcMode: "spline",
    keySplines: "0 0.2 0.8 1",
    keyTimes: "0;1",
    values: "0;53",
    dur: "1.4285714285714284s",
    repeatCount: "indefinite",
    attributeName: "r"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "-0.7142857142857142s",
    calcMode: "spline",
    keySplines: "0.2 0 0.8 1",
    keyTimes: "0;1",
    values: "1;0",
    dur: "1.4285714285714284s",
    repeatCount: "indefinite",
    attributeName: "opacity"
  })), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRipple4X1);
export default __webpack_public_path__ + "static/media/Ripple@4x-1.2e0766c18998fce5c03fab4dff809580.svg";
export { ForwardRef as ReactComponent };